'use client'

import type { ReactNode } from 'react'
import { openApply } from './ApplyDialog'

interface ApplyButtonProps {
  /** Course slug to preselect in the form */
  course?: string
  className?: string
  children: ReactNode
  /** Runs before the modal opens, e.g. to close a menu */
  onClick?: () => void
  'data-cta'?: string
}

/** Any "Apply" call to action: opens the application modal instead of navigating */
export function ApplyButton({ course, className, children, onClick, ...rest }: ApplyButtonProps) {
  const handleClick = () => {
    onClick?.()
    openApply(course)
  }
  return (
    <button type="button" onClick={handleClick} className={className} {...rest}>
      {children}
    </button>
  )
}
